'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n\n  ', '\n'], ['\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      position: absolute;\n      top: 100%;\n      opacity: ', ';\n      visibility: ', ';\n      ', ';\n    '], ['\n      position: absolute;\n      top: 100%;\n      opacity: ', ';\n      visibility: ', ';\n      ', ';\n    ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactDeviceDetect = require('react-device-detect');

var _polished = require('polished');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ActionsContainer = _styledComponents2.default.div(_templateObject, !_reactDeviceDetect.isMobile && (0, _styledComponents.css)(_templateObject2, function (_ref) {
  var visible = _ref.visible;
  return visible ? 1 : 0;
}, function (_ref2) {
  var visible = _ref2.visible;
  return visible ? 'visible' : 'hidden';
}, (0, _polished.transitions)('opacity .2s ease-in-out', 'visibility .2s ease-in-out')));

exports.default = ActionsContainer;